// src/components/Sidebar.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Wallet, HandCoins,
  Users, HelpCircle, Settings, LogOut, ChartCandlestick, X, Eye,
  BellDotIcon
} from 'lucide-react';
import logo from '../assets/logo.png';

export default function Sidebar({ active, mobileSidebarOpen, setMobileSidebarOpen }) {
  const navigate = useNavigate();

  return (
    <aside
      className={`bg-white border-end vh-100 d-flex flex-column justify-content-between sidebar
        ${mobileSidebarOpen ? 'position-fixed' : 'd-none'} d-md-flex`}
      style={{ width: '400px', top: 0, left: 0, zIndex: 1040 }}
    >
      {/* 🔝 Top Section */}
      <div>
        {/* Logo & Close Button */}
        <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
          <img src={logo} alt="Logo" style={{ height: '50px' }} />
          
          {/* Mobile Close Button */}
          <button
            className="btn btn-link text-dark d-md-none p-0"
            onClick={() => setMobileSidebarOpen(false)}
          >
            <X size={20} />
          </button>
        </div>

        {/* 📌 Navigation Links */}
        <nav className="nav flex-column p-3">
          <SidebarLink to="/dashboard" icon={<LayoutDashboard size={18} />} label="Dashboard" active={active === 'dashboard'} />
          <SidebarLink to="/notification" icon={<BellDotIcon size={18} />} label="Notification" active={active === 'notification'} />
          <SidebarLink to="/guests" icon={<Users size={18} />} label="Guest Records" active={active === 'guests'} />
          <SidebarLink to="/wallet" icon={<Wallet size={18} />} label="Wallet" active={active === 'wallet'} />
          
          {/* 🔴 NEW Watch List Link with badge */}
          <SidebarLink 
            to="/watchlist" 
            icon={<Eye size={18} />} 
            label="Watch List" 
            badge="5" 
            active={active === 'watchlist'} 
          />

          <SidebarLink to="/settings" icon={<Settings size={18} />} label="Settings" active={active === 'settings'} />
        </nav>

        {/* Promo/Info Box */}
        <div className="mx-3 mt-3 p-3 rounded text-white text-center" style={{ backgroundColor: '#002B5B' }}>
          <h4 className="fw-bold mb-2 cool-font text-white">Hotel ID Verify</h4>
          <small className="d-block mb-2">Fast, Secure Guest Identity Checks</small>
          <button className="btn btn-light btn-sm w-100">Learn More</button>
        </div>
      </div>

      {/* 🔻 Bottom Section */}
      <div className="border-top p-3">
        {/* Light Grey Help Button */}
        <button className="btn btn-light w-100 d-flex align-items-center mb-2"
        onClick={() => navigate("/help")}>
          
          <HelpCircle size={18} className="me-2" />
          Help
        </button>

        {/* Danger Sign Out Button */}
        <button
          onClick={() => navigate('/')}
          className="btn btn-danger w-100 d-flex align-items-center"
        >
          <LogOut size={18} className="me-2" />
          Sign Out
        </button>
      </div>
    </aside>
  );
}

/* 🔗 Sidebar Link Component */
function SidebarLink({ icon, label, to = "#", active, badge }) {
  return (
    <Link
      to={to}
      className={`d-flex align-items-center justify-content-between p-2 rounded mb-1 ${
        active ? 'bg-primary text-white fw-bold' : 'text-secondary'
      }`}
      style={{ textDecoration: 'none' }}
    >
      <div className="d-flex align-items-center">
        <span className="me-2">{icon}</span>
        {label}
      </div>

      {/* ✅ Show badge if present */}
      {badge && (
        <span className="badge bg-danger rounded-pill">{badge}</span>
      )}
    </Link>
  );
}
